import { BaseSidebarObject } from '@y42/gojs';
import { sidebarConfig } from '../../../config/config';
import { IZOrderableNode } from '../../common/models/node.interfaces';

export class NodeGroupNode extends BaseSidebarObject implements IZOrderableNode {
  constructor(
    public key = '',
    public category = '',
    public size = '100 100',
    public location = '0 0',
    public groupTitle = sidebarConfig.nodeGroupNode.defaultGroupTitle,
    public groupDescription = sidebarConfig.nodeGroupNode.defaultGroupDescription,
    public expanded = true,
    public layerName = '',
    public zOrder = NaN,
    public locked = false,
  ) {
    super();
  }
}
